/**
 * Global image constants for use throughout the application
 */
export const PLACEHOLDER_IMAGE =
  "https://media.evefant.com/placeholder_image_39cd3bbf9c.jpg";
